import React from "react";
import SystemHealthCard from "./components/SystemHealthCard";
import ErrorCard from "./components/ErrorCard";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { getScrollBarAppState } from "orion-components/AppState/Global/selectors";
import ClientConnection from "./components/ClientConnection";
import { systemHealthSelector } from "./selectors";

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

const hasError = (errorFlag, health) => {
	if (errorFlag) {
		return true;
	} else if (hasOwn(health, "success") && !health.success) {
		return true;
	} else {
		return false;
	}
};

const SystemHealth = () => {
	const locale = useSelector((state) => state.i18n.locale);
	const systemHealth = useSelector(systemHealthSelector);
	const error = useSelector((state) => hasError(state.systemHealth.hasApiError, state.systemHealth.health));
	const dir = useSelector((state) => getDir(state));
	const scrollBarsEnabled = useSelector((state) => getScrollBarAppState(state));

	return (
		<div
			style={{
				overflow: "scroll",
				height: "calc(100% - 80px)",
				width: scrollBarsEnabled ? "95%" : "90%",
				...(!scrollBarsEnabled && { margin: "auto" }),
				...(scrollBarsEnabled && { marginLeft: "auto" })
			}}
		>
			<ClientConnection />
			{!error ? (
				Object.keys(systemHealth).map((key) => {
					const health = systemHealth[key];
					return (
						<SystemHealthCard
							key={key}
							title={health.label}
							hasError={health.error}
							healthSystems={health.systems}
							dir={dir}
							locale={locale}
						/>
					);
				})
			) : (
				<ErrorCard dir={dir} />
			)}
		</div>
	);
};

export default SystemHealth;
